import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@shared/components/ui/shadcn/avatar';
import { cn } from '@shared/utils/utils';

interface ShopProps {
  src?: string;
  acronym?: string;
  name?: string;
  code?: string;
  description?: string;
  icon?: IconProp;
  className?: string;
}

export const Shop = ({
  acronym,
  src,
  name,
  code,
  description,
  icon,
  className,
}: ShopProps) => {
  const hasImage = !!src;
  const hasIcon = !src && !!icon;
  const testId = `${name?.split('.').join('-')}`;

  // Generar acrónimo si no se proporciona
  const generatedAcronym =
    acronym ||
    name
      ?.split(' ')
      .map((word) => word[0])
      .join('')
      .toUpperCase();

  return (
    <div
      id="testId"
      data-testid={testId}
      className={cn('flex items-center gap-2 py-[10px]', className)}
    >
      {hasImage && (
        <Avatar className="w-[20px] h-[20px] bg-white light:border light:border-card-border">
          <AvatarImage src={src} alt={name || description} />
          <AvatarFallback>{generatedAcronym}</AvatarFallback>
        </Avatar>
      )}

      {hasIcon && (
        <div className="w-[20px] h-[20px] flex items-center justify-center text-title">
          <FontAwesomeIcon icon={icon} className="text-base" />
        </div>
      )}

      <div className="flex flex-col leading-tight">
        {code ? (
          <>
            <span className="text-regular-mini text-title truncate line-clamp-1">
              {code}
            </span>
            <span className="text-regular-mini text-subtitle leading-snug line-clamp-1">
              {name}
            </span>
          </>
        ) : (
          <span className="text-regular-mini text-title line-clamp-1">
            {name}
          </span>
        )}
        {description && (
          <span className="text-regular-mini text-title line-clamp-2">
            {description}
          </span>
        )}
      </div>
    </div>
  );
};
